import { render, staticRenderFns } from "./NovaSenha.vue?vue&type=template&id=5b96d934"
import script from "./NovaSenha.vue?vue&type=script&lang=js"
export * from "./NovaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports